var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.373 11.2835V7.05784C14.373 5.37604 15.5764 4 17.0471 4H30.9521C32.4229 4 33.6262 5.37604 33.6262 7.05784V11.2835",
    stroke: "#202119",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3407 24.949V41.153C42.3407 42.7186 41.2201 44 39.851 44H8.14978C6.78074 44 5.66016 42.7188 5.66016 41.153V25.0439",
    stroke: "#202119",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6805 29.7413C11.9013 29.1673 4 26.2965 4 21.129V14.3914C4 12.8234 5.11834 11.5444 6.48963 11.5444H41.5104C42.8816 11.5444 44 12.8235 44 14.3914V21.129C44 26.3289 35.9988 29.2032 27.1535 29.7519",
    stroke: "#202119",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9297 26.9182H27.0708V30.1922C27.0708 31.9929 25.7824 33.4663 24.2077 33.4663H23.7928C22.2181 33.4663 20.9297 31.9929 20.9297 30.1922V26.9182Z",
    stroke: "#202119",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.e1e5d79e28b0b665e34a4b367f5b486c.svg";
export { ForwardRef as ReactComponent };